import HttpClient from "./HttpClient.js"
export default class Comment{
    constructor(comment){
        this.id = comment.id;
        this.text = comment.text;
        this.user_id = comment.user_id;
        this.user_name = comment.user_name;
        this.created_at = comment.created_at;
        this.updated_at = comment.updated_at;
    }

    static async create(input){
        const client = new HttpClient();
        const response = await client.instance.post("comments", input);
        return response.data;
    }
}